module.exports = __webpack_public_path__ + "static/media/average.df507a6e.svg";